import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button
} from '@chakra-ui/react';
import React from 'react';

export interface IConfirmationModalData {
  clickAction: () => void;
  title: string;
  descriptionText?: string | React.ReactNode;
  hideCancelButton?: boolean;
  isDestructive?: boolean;
  buttonName: string;
}

interface IProps {
  isOpen: boolean;
  titleText: string;
  confirmationButtonText: string;
  id?: string;
  descriptionText?: string | React.ReactNode;
  hideCancelButton?: boolean;
  isDestructive?: boolean;
  onClickSuccess: () => void;
  onClose: () => void;
}

const ConfirmationModal: React.FC<IProps> = props => {
  const {
    id = 'agent-view',
    isOpen,
    titleText,
    descriptionText = '',
    confirmationButtonText,
    hideCancelButton = false,
    isDestructive,
    onClickSuccess,
    onClose
  } = props;

  const showBody = Boolean(descriptionText?.toString()?.trim());
  const cancelRef = React.useRef<HTMLButtonElement>(null);

  const confirmButtonColorScheme = isDestructive ? 'red' : 'blue';

  return (
    <AlertDialog id={id} isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={onClose}>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader data-selector="confirmation-modal-title">{titleText}</AlertDialogHeader>

          {showBody && <AlertDialogBody data-selector="confirmation-modal-body">{descriptionText}</AlertDialogBody>}

          <AlertDialogFooter>
            {!hideCancelButton && (
              <Button
                id="cancel-button"
                data-selector="confirmation-modal-cancel-button"
                ref={cancelRef}
                onClick={onClose}
              >
                Cancel
              </Button>
            )}

            <Button
              id="confirm-button"
              data-selector="confirmation-modal-confirm-button"
              variant="solid"
              colorScheme={confirmButtonColorScheme}
              onClick={onClickSuccess}
              ml={hideCancelButton ? undefined : 3}
            >
              {confirmationButtonText}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};
export default ConfirmationModal;
